import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import applyFormat from '../functions/applyFormat';
import validateInputArray from '../functions/validateInputArray'; 
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation'; 
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const RebateComponentEditModal = ({ show, setShow, valuesArg, configArg, path, consortiumId, groupId, masterCompanyId, getRefreshData }) => {
    // get page context from parent
    const {
        snackbarAlert
    } = useContext(PageContext); 
    // get HTTP context from parent
    const {
        PUT, 
    } = useContext(HttpContext); 
    // initialize state 
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);

    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // validate consortium rebate components
            let componentsRequest = [{...values}]; 
            let checkError = false; 
            checkError = validateInputArray(
                componentsRequest,
                config, 
                dynamicValidation, 
                {}, 
                snackbarAlert, 
                error, 
                setError, 
                dynamicTransformation, 
                {}
            ); 
            // don't run request if error
            if (checkError) {
                reject(); 
                return; 
            }
            // get oldValues to attach to request 
            let temp = {...valuesArg}
            let oldValues = applyFormat(temp, config, {}, 0); 
            oldValues = dynamicTransformation(oldValues, config, {}); 
            // use PUT function to make request
            console.log({
                consortiumid: consortiumId, 
                groupid: groupId, 
                mastercompanyid: masterCompanyId,
                ...componentsRequest[0], 
                oldValues: oldValues
            }); 
            PUT(path, {
                consortiumid: consortiumId, 
                groupid: groupId, 
                mastercompanyid: masterCompanyId,
                ...componentsRequest[0], 
                oldValues: oldValues
            }).then(res => {
                console.log(res); 
                // hide spinner
                setShow(show => show = false); 
                // show snackbar on success
                snackbarAlert(true, 'Successfully uploaded data.', 'success'); 
                // refresh data 
                return getRefreshData(); 
            }).then(res => {
                console.log(res); 
                resolve(res); 
            }).catch(err => {
                snackbarAlert(true, 'Error uploading data.', 'error'); 
                // reject on error
                reject(err); 
            });  
        }); 
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (configArg){
            setConfig(config => config = configArg); 
        }
    }, [configArg]); 

    // useEffect to run on valuesArg change
    useEffect(() => {
        if (valuesArg) {
            // add ids to lookup values 
            let temp = {
                ...valuesArg // destructure to pass by value 
            }; 
            temp = applyFormat(temp, config, {}, 0); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [valuesArg]); 

    return (
        <> 
            <CCOffcanvas
                title='Edit Rebate Components '
                show={show}
                onCanvasClose={()=>setShow(show => show = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* map DynamicPageInput over all elements of input config */}
                        {config.map((el) => 
                            <>
                                <div>
                                    <DynamicPageInput data={values} setData={setValues} config={el} args={[]} width={'100%'} topAlignTypography={true} />
                                </div>
                            </>
                        )}
                    </div>
                    {/* button to submit company entitlement edit */}
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"} 
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                            onButtonClick={()=>setShow(show => show = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default RebateComponentEditModal; 